import { useCheckUserExistsByEmail } from './useCheckUserExistsByEmail'
import type { RegisterFormData } from '../../../schemas/checkoutLogin'

export function useCheckoutAuth() {
  const { login, isAuthenticated } = useAuth()
  const { user } = useAccount()
  const { register } = useSignup()
  const {
    userExistsByEmail,
    isLoading,
    error,
    checkUserExists,
    resetState: resetUserExistsState,
  } = useCheckUserExistsByEmail()

  const handleLogin = async (email: string, password: string) => {
    try {
      isLoading.value = true
      await login(email, password)
      return true
    } catch (err) {
      error.value = 'Invalid credentials'
      return false
    } finally {
      isLoading.value = false
    }
  }

  const handleRegister = async (data: RegisterFormData) => {
    try {
      isLoading.value = true
      await register(data)
      return true
    } catch (err) {
      error.value = 'Registration failed'
      return false
    } finally {
      isLoading.value = false
    }
  }

  const resetState = () => {
    error.value = null
    resetUserExistsState()
  }

  return {
    userExistsByEmail,
    isLoading,
    error,
    isAuthenticated,
    user,
    checkUserExists,
    handleLogin,
    handleRegister,
    resetState,
  }
}
